import { atom } from 'jotai';

// Atoms for the filter values
export const appFilterAtom = atom<string>('');
export const systemPackageFilterAtom = atom<string>('');
export const operationalSystemFilterAtom = atom<string>('');
// Atoms for the filter  version values
export const appVersionFilterAtom = atom<string>('');
export const systemPackageVersionFilterAtom = atom<string>('');
export const operationalSystemVersionFilterAtom = atom<string>('');
